<template>
    <i class="text-dark fas fa-book" aria-hidden="true"></i>
</template>